import { IconProps } from "./IconProps";

const ReceiveToMobileIcon: React.FC<IconProps> = ({
  width = 30,
  height = 30,
  color = "#0F5051",
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 21 16" fill="none">
      <path
        d="M6.5 16L5.1 14.575L7.675 12H0.5V10H7.675L5.1 7.425L6.5 6L11.5 11L6.5 16ZM14.5 10L9.5 5L14.5 0L15.9 1.425L13.325 4H20.5V6H13.325L15.9 8.575L14.5 10Z"
        fill={color}
      />
    </svg>
  );
};
export default ReceiveToMobileIcon;
